export const api = {
  queryVehicleAuthority: '/bms/vehiclebarrier/queryVehicleAuthority.json', // 查询车辆道闸车辆权限接口
  queryDeviceList: '/bms/vehiclebarrier/queryVehicleDevice.json', // 查询车辆道闸信息
  addCarAuth: '/bms/vehiclebarrier/addVehicleAuthority.json', // 新增车辆道闸信息
  updateCarAuth: '/bms/vehiclebarrier/updateVehicleAuthority.json', // 修改车辆道闸信息
  delCarAuth: '/bms/vehiclebarrier/deleteVehicleAuthority.json', // 删除车辆道闸信息
  queryCarAuthDetail: '/bms/vehiclebarrier/queryVehicleAuthorityDetails.json', // 查询车辆道闸详情
}
